import angular from 'angular';
import 'angulartics';
import 'angulartics-google-analytics';

export default angular.module('app.configs.angulartics', [
  'angulartics',
  'angulartics.google.analytics'
])
  .config(function($analyticsProvider){
    //$analyticsProvider.virtualPageviews(false);
    //$analyticsProvider.registerPageTrack(path => console.log('Page tracking: ', path));
    //$analyticsProvider.registerEventTrack(path => console.log('Event tracking: ', path));
  })



/** WEBPACK FOOTER **
 ** ./src/configs/angulartics.js
 **/